import React, { Component } from 'react'
import { Route, Switch, Router, withRouter } from 'react-router-dom'
import { history } from '../../helpers/history'
import Form from './Form'
import { SECTIONS } from './Section'
import checkRequiredFields from '../../helpers/check-required-fields'
import { Profile, SaveTheDate, Swag, HowToInvite, Reminder, ThankYou, Graphic, Message, When, Where, Signature, RSVPOptions, Cancel } from './forms'
import {
  DashboardContainer,
  EventContainer,
  GuestsContainer,
} from '../../containers'

const formComponents = {
  'profile': {
    component: Profile,
    previousPath: '/host/hub/dashboard',
  },
  'save-the-date': {
    component: SaveTheDate,
    previousPath: '/host/hub/dashboard',
    submitParams: { step_save_the_date_visited: true },
  },
  'swag': {
    component: Swag,
    previousPath: '/host/hub/dashboard',
  },
  'how-to-invite': {
    component: HowToInvite,
    previousPath: '/host/hub/dashboard',
    submitParams: { step_invite_visited: true },
  },
  'reminder': {
    component: Reminder,
    previousPath: '/host/hub/dashboard',
    submitParams: { step_reminder_visited: true },
  },
  'thank-you': {
    component: ThankYou,
    previousPath: '/host/hub/dashboard',
    submitParams: { step_thank_you_visited: true },
  },
  'graphic': {
    component: Graphic,
    previousPath: '/host/hub/event',
  },
  'message': {
    component: Message,
    previousPath: '/host/hub/event',
  },
  'when': {
    component: When,
    previousPath: '/host/hub/event',
  },
  'where': {
    component: Where,
    previousPath: '/host/hub/event',
  },
  'signature': {
    component: Signature,
    previousPath: '/host/hub/event',
  },
  'rsvp-options': {
    component: RSVPOptions,
    previousPath: '/host/hub/event',
  },
  'cancel': {
    component: Cancel,
    previousPath: '/host/hub/dashboard',
  },
}

class Host extends Component {
  previousLocation = this.props.location

  constructor(props) {
    super(props);
    this.state = {
      userEvent: null,
      currentUser: null,
      guests: [],
    }
    this.props.getEvent().then(this.props.loadGuests)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handlePublish = this.handlePublish.bind(this)
    this.updateProfile = this.updateProfile.bind(this)
    this.handleShare = this.handleShare.bind(this)
    this.handleSurvey = this.handleSurvey.bind(this)
  }

  componentWillUpdate(nextProps) {
    let { location } = this.props

    // set previousLocation if props.location is not modal
    if (
      nextProps.history.action !== "POP" &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userEvent) {
      this.setState({
        userEvent: nextProps.userEvent,
        error: ''
      })
    }
    if (nextProps.currentUser) {
      this.setState({
        currentUser: nextProps.currentUser,
        error: ''
      })
    }
    if (nextProps.userGuests) {
      this.setState({
        guests: nextProps.userGuests,
      })
    }
    if (nextProps.userError || nextProps.eventError) {
      this.setState({
        error: JSON.stringify(nextProps.userError) + " " + JSON.stringify(nextProps.eventError),
      })
    }
  }

  renderFormRoute = (match, isModal) => {
    const { userLoading } = this.props
    const { userEvent, currentUser, guests } = this.state
    const FormComponent = formComponents[match.params.form].component;
    if (!userEvent || !currentUser) {
      return (<div>Loading...</div>)
    } else {
      const valid = checkRequiredFields(SECTIONS[match.params.form].requiredFields, userEvent, currentUser)
      return (
        <Form
          onSubmit={(e) => this.handleSubmit(e, formComponents[match.params.form].previousPath, match.params.form)}
          error={this.state.error}
          isModal={isModal}
          previousPath={formComponents[match.params.form].previousPath}
          valid={valid}
          currentUser={currentUser}
        >
          <FormComponent currentUser={currentUser} userEvent={userEvent} guests={guests} onChange={this.handleChange}/>
        </Form>
      )
    }
  }

  handleChange(e) {
    // handle attribute change on user or event
    // reads nested input name: i.e. "objectType[attribute]", e.g. "currentUser[firstname]"
    const matches = e.target.name.match(/(.*)\[(.*)\]/)
    const objectType = matches[1]
    const attribute = matches[2]
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    this.setState({
      [objectType]: {
        ...this.state[objectType],
        [attribute]: value,
      }
    })
  }

  updateProfile(redirectPath) {
    this.props.updateProfile(this.state.userEvent, this.state.currentUser, () => {
      if (redirectPath) {
        this.props.history.push(redirectPath)
      }
    })
  }

  handleSubmit(e, previousPath, formSlug) {
    if (typeof formSlug !== 'undefined' && typeof formComponents[formSlug].submitParams !== 'undefined') {
      this.setState({
        userEvent: {
          ...this.state.userEvent,
          ...formComponents[formSlug].submitParams,
        }
      }, () => {
        this.updateProfile(previousPath)
      })
    }
    else {
      this.updateProfile(previousPath)
    }
  }

  handlePublish(e, previousPath) {
    this.setState({
      userEvent: {
        ...this.state.userEvent,
        published: true,
      }
    }, () => {
      this.updateProfile('/host/hub/dashboard')
    })
  }

  handleShare() {
    this.setState({
      userEvent: {
        ...this.state.userEvent,
        step_share_visited: true,
      }
    }, () => {
      this.props.updateProfile(this.state.userEvent, this.state.currentUser, () => {
        setTimeout(() => {
          window.location = process.env.REACT_APP_BASE_URL + "/share/" + this.state.userEvent.token + "/host";
        }, 1000);
      })
    })
  }

  handleSurvey() {
    console.log('we make it here?')
    this.setState({
      userEvent: {
        ...this.state.userEvent,
        step_survey_visited: true,
      }
    }, () => {
      this.props.updateProfile(this.state.userEvent, this.state.currentUser, () => {
        window.location = "https://denimandsteel.com"
      })
    })
  }

  render() {
    const { userLoading } = this.props
    const { userEvent, currentUser, guests } = this.state
    let { location } = this.props;

    var mq = window.matchMedia( "(max-width: 600px)" );
    const isMobile = mq.matches

    let isModal = !!(
      !isMobile &&
      location.state &&
      location.state.modal &&
      this.previousLocation !== location
    )
    document.body.style.cssText = isModal ? 'overflow: hidden' : '' // Prevent scrolling rest of page when modal open.

    return (
      <Router history={history}>
        <React.Fragment>
          <Switch location={isModal ? this.previousLocation : location}>
            <Route exact path="/host/hub/dashboard" render={(props) => <DashboardContainer {...props} currentUser={currentUser} userEvent={userEvent} guests={guests} onShare={this.handleShare} onSurvey={this.handleSurvey} />} />
            <Route exact path="/host/hub/event" render={(props) => <EventContainer {...props} currentUser={currentUser} userEvent={userEvent} guests={guests} onPublish={this.handlePublish} />} />
            <Route exact path="/host/hub/guests" render={(props) => <GuestsContainer {...props} currentUser={currentUser} userEvent={userEvent} guests={guests} />} />
            <Route exact path="/host/hub/forms/:form" render={({match}) => this.renderFormRoute(match, isModal)} />
          </Switch>
          {isModal ? <Route path="/host/hub/forms/:form" render={({match}) => this.renderFormRoute(match, isModal)} /> : null}
        </React.Fragment>
      </Router>
    )
  }
}

export default withRouter(Host)
